import api from "@/api/apiConfig"
import {
  Post,
  Get,
  Put,
} from './base/baseAjax'
let getStaff = (param) => {
  return Post({
    url: api.staff.getStaff,
    bodyParam: param
  })
}
let editDepart = (param) => {
  return Put({
    url: api.staff.editDepart,
    bodyParam: param
  })
}
let quit = (param) => {
  return Put({
    url: api.staff.quit,
    bodyParam: param
  })
}
let cancelQuit = (param) => {
  return Put({
    url: api.staff.cancelQuit,
    PathParam: param
  })
}
let exportAll = () => {
  return Get({
    url: api.staff.exportAll,
    config:{
      timeout:600000
    }
  })
}
let getDetail = (param) => {
  return Get({
    url: api.staff.getDetail,
    PathParam: param
  })
}
let editStaff = (param) => {
  return Put({
    url: api.staff.editStaff,
    bodyParam: param
  })
}
let addStaff = (param) => {
  return Post({
    url: api.staff.addStaff,
    bodyParam: param
  })
}
let downloadAll = (param) => {
  return Post({
    url: api.staff.downloadAll,
    bodyParam: param,
    config:{
      timeout:600000
    }
  })
}
export default {
  getStaff,
  editDepart,
  quit,
  cancelQuit,
  exportAll,
  getDetail,
  editStaff,
  addStaff,
  downloadAll
}



// WEBPACK FOOTER //
// ./src/services/staff.js